export function secondToDatetime(duration) {
  const durationNumber = Number(duration);
  const seconds = durationNumber % 60;
  const totalMinutes = Math.floor(durationNumber / 60);
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  // 不足两位数，前面补0
  const secondsFormat = seconds.toString().padStart(2, "0");
  const minutesFormat = minutes.toString().padStart(2, "0");
  const hoursFormat = hours.toString().padStart(2, "0");
  if (hours > 0) {
    return `${hoursFormat}:${minutesFormat}:${secondsFormat}`;
  }
  if (minutes > 0) {
    return `00:${minutesFormat}:${secondsFormat}`;
  }
  return `00:00:${secondsFormat}`;
}
